import "./SelectRegistry.css"

import { REGISTER_TEXTS } from "constants/text.constants"
import { IRegister } from "types/sharedTypes"
import { useEffect, useMemo, useState } from "react"

type SelectRegistryProps = {
    registries: IRegister[]
    setRegistryId: React.Dispatch<React.SetStateAction<string>>
    name?: string
    flexDirection?: "" | "column"
    /** Controlled usage (rekommenderad) */
    value?: string
    /** För bakåtkompatibilitet – äldre kod använder defaultValue */
    defaultValue?: string
    noDefaultValue?: boolean
}

// Hjälpfunktioner för att plocka Id/Name även om backend döpt fälten annorlunda
const getRegistryId = (r: any): string =>
    r?.Id ??
    r?.id ??
    r?.RegistryId ??
    r?.registryId ??
    r?.Key ??
    r?.value ??
    ""

const getRegistryName = (r: any): string =>
    r?.Name ??
    r?.name ??
    r?.RegistryName ??
    r?.Text ??
    r?.text ??
    r?.DisplayName ??
    getRegistryId(r) ??
    ""

const SelectRegistry = ({
    registries,
    setRegistryId,
    name = REGISTER_TEXTS.SELECT_REGISTRY,
    flexDirection = "",
    value,
    defaultValue,
    noDefaultValue,
}: SelectRegistryProps) => {
    // Ta bort null/undefined/hål
    const normalizedRegistries = useMemo(
        () => registries.filter((r) => !!r),
        [registries]
    )

    const first = normalizedRegistries[0]
    const firstId = getRegistryId(first)

    // internt värde när parent inte styr value/defaultValue
    const [internalValue, setInternalValue] = useState<string>("")

    useEffect(() => {
        // Prioritet: value → defaultValue → första riktiga registret
       const initial = value ?? defaultValue ?? ""

        setInternalValue(initial)

        // Om parent inte styr själv: pusha upp första Id:et
        if (value === undefined && defaultValue === undefined && initial) {
            setRegistryId(initial)
        }
    }, [value, defaultValue, firstId, setRegistryId])

    const effectiveValue = value ?? defaultValue ?? internalValue

    return (
        <div className={`selectRegistryContainer ${flexDirection}`}>
            <label htmlFor="selectRegistry">{name}</label>
            <select
                id="selectRegistry"
                name="selectRegistry"
                className="registryDropdown"
                value={effectiveValue}
                onChange={(e) => {
                    console.log("🔽 onChange value:", e.target.value)
                    setInternalValue(e.target.value)
                    setRegistryId(e.target.value)
                }}
            >
                {noDefaultValue && (
                    <option value="">
                        {REGISTER_TEXTS.CHOOSE_REGISTER}
                    </option>
                )}
                {normalizedRegistries.map((registry, index) => {
                    const id = getRegistryId(registry)
                    const displayName = getRegistryName(registry)

                    return (
                        <option key={id || index} value={id}>
                            {displayName}
                        </option>
                    )
                })}
            </select>
        </div>
    )
}

export default SelectRegistry
